var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace2Left(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 997.8 926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n\n      .cls-face-2 {\n        fill: #fff;\n      }\n\n      .cls-face-3 {\n        fill: #42210b;\n      }\n\n      .cls-face-4 {\n        fill: #f44d41;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M520.71,0h0c263.31,0,477.09,213.78,477.09,477.09v104.95c0,189.84-154.12,343.96-343.96,343.96h-266.26c-189.84,0-343.96-154.12-343.96-343.96v-104.95C43.62,213.78,257.4,0,520.71,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 723.45,
    cy: 586.58,
    r: 120.78
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-3",
    d: "M201.6,679.08h-.02c-5.68-1.65-11.79,1.12-14.06,6.57-13.57,32.63-45.19,55.4-80.06,56.56-8.91.29-17.63-.82-25.96-3.13,4.66,9.07,9.73,17.89,15.15,26.47,2.64.19,5.29.3,7.96.3,1.21,0,2.42-.02,3.63-.06,44.74-1.48,83.88-29.43,101.01-70.85,2.69-6.5-.88-13.91-7.64-15.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-2",
    cx: 327.51,
    cy: 459.67,
    rx: 108.17,
    ry: 110.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-3",
    d: "M327.51,576.39c-62.96,0-114.18-52.36-114.18-116.72s51.22-116.72,114.18-116.72,114.18,52.36,114.18,116.72-51.22,116.72-114.18,116.72ZM327.51,354.97c-56.33,0-102.16,46.97-102.16,104.7s45.83,104.7,102.16,104.7,102.16-46.97,102.16-104.7-45.83-104.7-102.16-104.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-3",
    cx: 289.63,
    cy: 459.94,
    rx: 66.75,
    ry: 68.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-3",
    d: "M289.63,534.26c-40.12,0-72.76-33.34-72.76-74.32s32.64-74.32,72.76-74.32,72.75,33.34,72.75,74.32-32.64,74.32-72.75,74.32ZM289.63,397.64c-33.49,0-60.74,27.95-60.74,62.3s27.25,62.3,60.74,62.3,60.73-27.95,60.73-62.3-27.24-62.3-60.73-62.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-3",
    d: "M409.66,335.53c-8.95-7.91-41.73-33.51-87.79-30.56-35.79,2.26-60.79,20.1-72.5,30.54l-7.99-8.98c12.87-11.47,40.35-31.07,79.74-33.56,49.35-3.11,83.92,22.42,96.51,33.55l-7.96,9.01Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-face-4",
    x: 0,
    y: 548.23,
    width: 113.76,
    height: 77.19,
    rx: 38.6,
    ry: 38.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace2Left);
export default __webpack_public_path__ + "static/media/face2-left.e7d5ba471d3c67cae042ce2d1b0802c5.svg";
export { ForwardRef as ReactComponent };